export default __webpack_public_path__ + "static/media/Wall_Orange_Gate.256.66440139.png";